module.exports = {
  env: {
    mode: process.env.REACT_APP_ENV || "stage",
    packageName: "it.dietasocial.web",
    forceProduction: process.env.REACT_APP_FORCE_PRODUCTION === "true",
    freeRoutes: process.env.REACT_APP_FREE_ROUTES !== "false",
    googleMapsApiKey: "AIzaSyDuhNPYxpnJ4s5rHzk8gIYvcEbwx7BO2sc",
    mandatoryInstall: process.env.REACT_APP_MANDATORY_INSTALL === "true",
    native: {
      url: "https://stage.dietasocial.it",
      node: "https://api.dietasocial.it:3001",
      app: "https://localhost",
    },
    stage: {
      url: "https://stage.dietasocial.it",
      node: "https://api.dietasocial.it:3001",
      app: "https://sandbox.dietasocial.it",
    },
    local: {
      url: "http://localhost:14100",
      node: "https://api.dietasocial.it:3001",
      app: "https://localhost",
    },
    prod: {
      url: "https://simon.dietasocial.it",
      node: "https://api.dietasocial.it:3001",
      app: "https://app.dietasocial.it",
    },
    preprod: {
      url: "https://simon.dietasocial.it",
      node: "https://api.dietasocial.it:3001",
      app: "https://webapp.dietasocial.it",
    },
  },
};
